import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-6 h-6" }

import { computed, ref } from "vue"
import EmojiPicker from "vue3-emoji-picker"
import { EmojiHappyIcon, XIcon } from "@heroicons/vue/outline"
import { Emoji } from "@/shared/models/emoji"
import "vue3-emoji-picker/css"

interface Props {
    pickerClasses?: string
    isAlignedTop?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsEmojiPicker',
  props: {
    pickerClasses: {},
    isAlignedTop: { type: Boolean }
  },
  emits: ["sendEmoji"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const isShowEmojiPicker = ref(false)
const emojiPickerAlign = computed(() => (props.isAlignedTop ? "bottom-7" : "-top-[330px] -left-[255px]"))
const xIconAlign = computed(() => (props.isAlignedTop ? "bottom-[315px] left-[242px]" : "-top-[320px] -left-[15px] "))

function onSelectEmoji(emoji: Emoji) {
    emit("sendEmoji", emoji.i)
}

function toggleEmojiPicker() {
    isShowEmojiPicker.value = !isShowEmojiPicker.value
}

function hideEmojiPicker() {
    isShowEmojiPicker.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(EmojiHappyIcon), {
      class: "w-6 h-6 mr-4 cursor-pointer text-gray-400 hover:text-gray-600",
      onClick: toggleEmojiPicker
    }),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["absolute z-50 -right-[245px] w-5", xIconAlign.value])
    }, [
      _createVNode(_unref(XIcon), {
        class: "h-6 w-6 cursor-pointer text-gray-400 hover:text-gray-500",
        onClick: hideEmojiPicker
      })
    ], 2), [
      [_vShow, isShowEmojiPicker.value]
    ]),
    _withDirectives(_createVNode(_unref(EmojiPicker), {
      native: true,
      class: _normalizeClass(["absolute z-40", [_ctx.pickerClasses, emojiPickerAlign.value, 'emoji-picker']]),
      onSelect: onSelectEmoji
    }, null, 8, ["class"]), [
      [_vShow, isShowEmojiPicker.value]
    ])
  ]))
}
}

})